import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=50a30cef&scoped=true"
import script from "./freight.vue?vue&type=script&lang=js"
export * from "./freight.vue?vue&type=script&lang=js"
import style0 from "./freight.vue?vue&type=style&index=0&id=50a30cef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_babel-core@7.0.0-bridge.0_@babel+core@7.29._1a562a7ff44e47125e24b47fdbb3ae4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a30cef",
  null
  
)

export default component.exports